import { UserCarouselSlug } from 'api/userCarousels/types'
import { useTranslation } from 'services/i18n'

import type { FC } from 'react'

type Props = {
  carouselSlug: UserCarouselSlug
  currentScreen: 'welcome' | 'credibility' | 'security' | 'feedback'
}

export const ScreenText: FC<Props> = ({ carouselSlug, currentScreen }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_carousels',
  })

  return (
    <>
      <div className="text-center font-display text-2xl text-default">
        {t(`carousels.${carouselSlug}.screens.${currentScreen}.header`)}
      </div>
      <div className="mt-3 text-center text-base">
        {t(`carousels.${carouselSlug}.screens.${currentScreen}.description`)}
      </div>
    </>
  )
}
